export enum LoraMessageType {
  JoinRequest = 0,
  JoinAccept = 1,
  UnconfirmedDataUp = 2,
  UnconfirmedDataDown = 3,
  ConfirmedDataUp = 4,
  ConfirmedDataDown = 5,
  RejoinRequest = 6,
  Proprietary = 7,
  Unknown = 255,
  UnknownUplink = 254,
  UnknownDownlink = 253,
}
